import Image from "next/image";
import { useState } from "react";
import { useCheckoutStore } from "@/lib/store/checkout";

// const tempImages = [
//   "https://images.unsplash.com/photo-1518105779142-d975f22f1b0a?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
//   "https://images.unsplash.com/photo-1568402102990-bc541580b59f?q=80&w=987&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
//   "https://images.unsplash.com/photo-1465256410760-10640339c72c?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
//   "https://images.unsplash.com/photo-1564678164-f00ad53a38e6?q=80&w=987&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
// ];

export const ImageCarousel = () => {
  const productImages = useCheckoutStore((s) => s.config?.productImages ?? []);
  const [failedImages, setFailedImages] = useState<string[]>([]);
  const images = productImages.filter((i) => !failedImages.includes(i));

  const onImageError = (image: string) => () => {
    setFailedImages((failed) => [...failed, image]);
  };

  if (images.length < 1) return null;

  return (
    <div className="-mx-4 md:-mx-6 lg:-ml-6 lg:-mr-8 relative">
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-8 bg-linear-to-r from-surface to-60% to-transparent lg:from-surface-alt" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-8 bg-linear-to-l from-surface to-60% to-transparent lg:from-surface-alt" />
      <div className="lg:scrollbar-none flex h-auto snap-x snap-mandatory gap-4 overflow-y-hidden overflow-x-scroll pb-4">
        <div aria-hidden className="w-0 shrink-0 md:w-2 lg:w-4" />
        {images.map((image) => (
          <div
            className="h-56 w-auto shrink-0 snap-center drop-shadow-md"
            key={image}
          >
            <Image
              src={image}
              quality={100}
              width={720}
              height={1280}
              alt="product"
              className="h-56 w-auto shrink-0 rounded-lg object-cover"
              onError={onImageError(image)}
            />
          </div>
        ))}
        <div aria-hidden className="w-0 shrink-0 md:w-2 lg:w-4" />
      </div>
    </div>
  );
};
